// tslint:disable
import { Service, service } from "./di";

@service("sessionStorageService")
export class SessionStorageService extends Service {

	isAvailable() {
		const storage = window.sessionStorage;
		try {
			storage.setItem('test', 'test');
			storage.removeItem('test');
			return true;
		} catch (e) {
			return false;
		}
	}

	getItem(key: string) {
		try {
			return window.sessionStorage.getItem(key);
		} catch (e) {
			return undefined;
		}
		
	}
	
	setItem(key: string, value: string) {
		try {
			window.sessionStorage.setItem(key, value);
		} catch (e) {
			console.log("session storage is not available");
		}
		
	}
}
